export default __webpack_public_path__ + "static/media/gridImage2.5f53b5d6.jpg";